import React from 'react'
import { Card, ListItem } from '@mui/material'
import withStyles from '@mui/styles/withStyles'

const styles = () => ({
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between !important',
    width: '100% !important',
    maxWidth: 400
  },

  notificationUnitText2: {
    overflow: 'hidden',
    // maxWidth: '400px',
    width: 'auto',
    borderRadius: '10px !important',
  },
})

const DealsNotifiModel = ({
  classes,
  clickEeventHandler,
  notification,
  interiorCardComponent,
}) => {
  return (
    <ListItem
      className={classes.listItem}
      onClick={() => clickEeventHandler()}
    >
      <section className={classes.notificationUnitText2}>
        {interiorCardComponent}
      </section>
    </ListItem>
  )
}

const WrappedDealsNotifiModel = withStyles(styles)(DealsNotifiModel)

export default WrappedDealsNotifiModel
